'use client'

import { styled } from '@mui/material'
import { PageLayout } from '../pageLayout'

export const Styled404 = styled(PageLayout)(({ theme }) => ({
  '.not-found': {
    background: theme.palette.background.default,
    color: theme.palette.primary.dark,
    padding: theme.spacing(0, 3),
    width: '100%',
    minHeight: 600,
    alignItems: 'center',
    justifyContent: 'center',
    '.message-wrapper': {
      justifyContent: 'center',
      marginTop: theme.spacing(8),
      [theme.breakpoints.up('md')]: {
        fontSize: '3rem',
        marginTop: 0,
        marginBottom: theme.spacing(2),
      },
    },
    '.message': {
      fontSize: '4rem',
      lineHeight: 1,
      fontWeight: 600,
      textAlign: 'center',
      color: theme.palette.primary.dark,
      marginBottom: theme.spacing(2),
    },
    '.MuiButton-root': {
      width: 'fit-content',
      margin: '30px auto',
    },
  },
}))
